import { Route } from '@angular/router';
import { OwnerResolver } from '@h5s/feature-owner';
import { UserPreferencesResolver } from '@h5s/feature-user';
import { propertySelectedGuard, updateRequiredGuard } from '@h5s/guards';

export const appRoutes: Route[] = [
  {
    path: 'pick-your-place',
    loadComponent: () => import('@h5s/feature-property-selection').then((c) => c.FeaturePropertySelectionComponent),
    canActivate: [updateRequiredGuard],
  },
  {
    path: '',
    loadComponent: () => import('@h5s/feature-shell').then((c) => c.FeatureShellComponent),
    loadChildren: () => import('./routes/pms-web.routes').then((x) => x.PmsWebRoutes),
    resolve: { owner: OwnerResolver, userPreferences: UserPreferencesResolver },
    canActivate: [propertySelectedGuard, updateRequiredGuard],
    canActivateChild: [updateRequiredGuard],
  },
];
